import * as Actions from 'app/store/actions/calling/calling.actions';

const initialState = {
    displayUIWhenCalling: false,
    initAudioCall: false,
    isInAudioCall: false,
    audioCallWithChat: null,
	notificationTune: false,
	isVideoCall: false,
	isCallAccepted: false,
	isCallAvailable:false,
	screensharing:false,
    data:[],
	displayUsersList:false,
	panelRightDisplayed:false,
	panelDisplayed:null,
	tokbox:[],
	oldSession:[],
	outputs:[],
	inputs:[],
	camera:[],
	cameraSelected:null,
	inputSelected:null,
	outputSelected:null,
	publisher:[],
	effect:[],
	clearScreen:false,
	drawingMode:false,
	backgroundsUploaded:[],
	sessionId:null,
	chatId:null
};

const calling = (state = initialState, action) => {
	switch (action.type) {
		case Actions.UPDATE_CHAT_ID: {
			return {
				...state,
				chatId: action.payload
			};
		}
		case Actions.ADD_USER_TO_GROUP: {
			const newUser = action.payload; // The new user object to be added
			const updatedData = {
				...state.data,
				chatAllUser: [...state.data.chatAllUser, newUser], // Add the new user to the existing chatAllUser array
			};
			return {
				...state,
				data: updatedData, // Update the data object with the updated chatAllUser array
			};
		}
		case Actions.SET_SESSION_ID: {
			return {
				...state,
				sessionId:action.payload,
			};
		}
		case Actions.GET_BACKGROUND_VIDEO: {
			return {
				...state,
				backgroundsUploaded:action.payload,
			};
		}
		case Actions.DRAWING_MODE: {
			return {
				...state,
				drawingMode:action.payload,
			};
		}
		case Actions.DRAW_CLEAR_SCREEN_RESET: {
			return {
				...state,
				clearScreen:false,
			};
		}
		case Actions.DRAW_CLEAR_SCREEN: {
			return {
				...state,
				clearScreen:true,
			};
		}
		case Actions.SET_SCREENSHARING: {
			return {
				...state,
				screensharing:action.payload,
			};
		}
		case Actions.SET_VIDEO_EFFECT: {
			return {
				...state,
				effect:action.payload,
			};
		}
		case Actions.SET_PUBLISHER: {
			return {
				...state,
				publisher:action.payload,
			};
		}
		case Actions.RIGHT_PANEL_DISPLAYED: {
			return {
				...state,
				panelRightDisplayed:action.payload,
				panelDisplayed: action.panel
			};
		}
		case Actions.SET_VIDEO_INPUT: {
			return {
				...state,
				cameraSelected:action.payload,
			};
		}
		case Actions.SET_AUDIO_INPUT: {
			return {
				...state,
				inputSelected:action.payload,
			};
		}
		case Actions.SET_AUDIO_OUTPUT: {
			return {
				...state,
				outputSelected:action.payload,
			};
		}
		case Actions.SET_VIDEO_INPUTS: {
			return {
				...state,
				camera:action.payload,
			};
		}
		case Actions.SET_AUDIO_INPUTS: {
			return {
				...state,
				inputs:action.payload,
			};
		}
		case Actions.SET_AUDIO_OUTPUTS: {
			return {
				...state,
				outputs:action.payload,
			};
		}
		case Actions.JOINING_SESSION: {
			return {
				...state,
				oldSession:action.payload,
			};
		}
		case Actions.SET_TOKBOX_DETAIL: {
			return {
				...state,
				tokbox:action.payload,
			};
		}
		case Actions.DISPLAY_USERS_LIST: {
			return {
				...state,
				displayUsersList:action.payload,
				panelRightDisplayed:true,
				panelDisplayed: action.panel
			};
		}
		case Actions.DECLINE_CALL: {
            console.log("Call has been declined, but call is still running on for user who running initially")
			return {
				...state,
				isCallAvailable:true,
			};
		}
		case Actions.DISPLAY_UI_CALLING: {
            console.log("DISPLAY_UI_CALLING", action)
			return {
				...state,
				displayUIWhenCalling: action.payload,
                data:action.data,
				notificationTune: true,
			};
		}
        case Actions.CALLING_END: {
			return {
				screensharing:false,
                displayUIWhenCalling: false,
                initAudioCall: false,
                isInAudioCall: false,
                audioCallWithChat: null,
                notificationTune: false,
                isVideoCall: false,
                isCallAccepted: false,
				isCallAvailable:false,
                data:[]
			};
		}
		case Actions.CALLING_INIT: {
			return {
				...state,
				initAudioCall: true,
				isInAudioCall: false,
				audioCallWithChat : action.payload.chatId,
				chat:action.payload,
				isCallAvailable:true,
				notificationTune: true,
				chatId:action.payload.chatId
			};
		}
		case Actions.NOTIFICATION_TUNE: {
			return {
				...state,
				notificationTune : action.payload,
				initAudioCall: action.payload === false && false,
			};
		}
		case Actions.IS_VIDEO_CALL: {
			return {
				...state,
				isVideoCall : action.payload
			};
		}
		case Actions.IS_CALL_ACCEPTED: {
			return {
				...state,
				isCallAccepted : action.payload,
				initAudioCall: action.payload === false && false,
                notificationTune: false
			};
		}
        case Actions.CALL_INFORMATIONS: {
			return {
				...state,
				data : action.payload,
			};
		}
		default: {
			return state;
		}
	}
};

export default calling;
